import {
  IconAlertTriangle,
  IconArrowRight,
  IconBuildingBank,
  IconBuildingCommunity,
  IconBuildingHospital,
  IconChartLine,
  IconCoin,
  IconCurrencyYen,
  IconDownload,
  IconDroplet,
  IconExclamationCircle,
  IconFileText,
  IconHome,
  IconLayersSubtract,
  IconLeaf,
  IconLink,
  IconMap2,
  IconMapPin,
  IconMountain,
  IconNotebook,
  IconRipple,
  IconSchool,
  IconSearch,
  IconShieldCheck,
  IconSparkles,
  IconStar,
  IconStethoscope,
  IconTrain,
  IconTree,
  IconUsersGroup,
  IconWaveSine,
  IconWind,
  type Icon as TablerIcon,
} from '@tabler/icons-react';

const REGISTRY = {
  'alert-triangle': IconAlertTriangle,
  'arrow-right': IconArrowRight,
  'building-bank': IconBuildingBank,
  'building-community': IconBuildingCommunity,
  'building-hospital': IconBuildingHospital,
  'chart-line': IconChartLine,
  coin: IconCoin,
  'currency-yen': IconCurrencyYen,
  download: IconDownload,
  droplet: IconDroplet,
  'exclamation-circle': IconExclamationCircle,
  'file-text': IconFileText,
  home: IconHome,
  'layers-subtract': IconLayersSubtract,
  leaf: IconLeaf,
  link: IconLink,
  'map-2': IconMap2,
  'map-pin': IconMapPin,
  mountain: IconMountain,
  notebook: IconNotebook,
  ripple: IconRipple,
  school: IconSchool,
  search: IconSearch,
  'shield-check': IconShieldCheck,
  sparkles: IconSparkles,
  star: IconStar,
  stethoscope: IconStethoscope,
  train: IconTrain,
  tree: IconTree,
  'users-group': IconUsersGroup,
  'wave-sine': IconWaveSine,
  wind: IconWind,
} as const satisfies Record<string, TablerIcon>;

export type IconName = keyof typeof REGISTRY;

type Props = {
  name: IconName;
  size?: number;
  color?: string;
  strokeWidth?: number;
  className?: string;
};

export default function Icon({
  name,
  size = 20,
  color,
  strokeWidth = 1.5,
  className,
}: Props) {
  const Tabler = REGISTRY[name];
  return (
    <Tabler size={size} color={color} stroke={strokeWidth} className={className} />
  );
}
